import { FormControl, MenuItem, Select, SxProps, Tooltip, useTheme, Theme, InputLabel, OutlinedInput } from '@mui/material';

interface TherapistCountFilterProps {
  selectedCounts: number[] | 'all';
  onChange: (value: number[] | 'all') => void;
  availableCounts: number[];
  sx?: SxProps;
}

const TherapistCountFilter = ({ selectedCounts, onChange, availableCounts, sx }: TherapistCountFilterProps) => {
  const theme = useTheme();
  const sortedCounts = [...availableCounts].sort((a, b) => a - b);
  
  const getStyles = (count: number, selectedCounts: number[] | 'all', theme: Theme) => {
    const isSelected = selectedCounts !== 'all' && selectedCounts.includes(count);
    return {
      fontWeight: isSelected
        ? theme.typography.fontWeightMedium
        : theme.typography.fontWeightRegular,
      backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.08)' : 'transparent',
    };
  };
  
  const handleChange = (event: any) => {
    const value = event.target.value;
    onChange(value);
  };

  const renderValue = (selected: any) => {
    if (selected === 'all' || selected.length === 0) {
      return ''; // Return empty string to show the label
    }
    
    // Display as comma-separated numbers
    const sortedSelected = [...selected].sort((a, b) => a - b);
    return sortedSelected.join(', ');
  };
  
  return (
    <Tooltip 
      describeChild 
      title="Nach Anzahl der Therapeuten filtern" 
      placement="top" 
      slotProps={{
        popper: {
          modifiers: [{
            name: 'offset',
            options: {
              offset: [0, -15],
            },
          }],
        },
      }}
    >
      <FormControl
        sx={{
          cursor: "pointer",
          padding: "0px",
          margin: "0px",
          backgroundColor: "white",
          m: 0,
          width: 160,
          ".MuiInputBase-root": {
            height: 25,
            padding: "0px",
            margin: "0px",
            fontSize: "12px",
            fontFamily: "Inter",
            backgroundColor: "white",
          },
          ".MuiInputBase-input": {
            backgroundColor: "white",
            marginBottom: "-5px",
            padding: "0px",
          },
          ...(sx || {}),
        }}
        size="small"
      >
        <InputLabel
          id="therapist-count-filter-label"
          sx={{
            fontSize: '12px',
            fontFamily: 'Inter',
            transformOrigin: 'top left',
            // center label vertically for small input
            transform: 'translate(14px, 4px) scale(1)',
            '&.MuiInputLabel-shrink': {
              transform: 'translate(14px, -8px) scale(0.75)'
            }
          }}
        >
          Anzahl Therapeuten
        </InputLabel>
        <Select 
          labelId="therapist-count-filter-label"
          multiple
          value={selectedCounts === 'all' ? [] : selectedCounts} 
          onChange={handleChange}
          input={<OutlinedInput label="Anzahl Therapeuten" />}
          renderValue={renderValue}
          sx={{ 
            '.MuiOutlinedInput-notchedOutline': { 
              border: 0, 
              alignItems: "center" 
            }
          }} 
          size="small"
        >
          {sortedCounts.map(count => (
            <MenuItem 
              key={count} 
              value={count} 
              style={getStyles(count, selectedCounts, theme)}
              sx={{ 
                fontSize: '12px', 
                fontFamily: 'Inter'
              }}
            >
              {count}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Tooltip>
  );
};

export default TherapistCountFilter;
